import * as Yup from 'yup';
import type { InferType } from 'yup';

export type ContactFormData = InferType<typeof contactFormValidationSchema>;

export const contactFormValidationSchema = Yup.object({
  contact_reason: Yup.string()
    .notOneOf(['default'], 'Contact reason must be selected')
    .required('Contact reason must be selected'),
  form_id: Yup.string().required('Reason is required'),
  first_name: Yup.string().required('First name is required'),
  last_name: Yup.string().required('Last name is required'),
  user_email: Yup.string()
    .email('Invalid email address')
    .required('Email address is required'),
  confirm_email: Yup.string()
    .oneOf([Yup.ref('user_email'), ''], 'Does not match with Email address')
    .email('Invalid email address')
    .required('Confirm email address is required'),
  street_1: Yup.string().when('contact_reason', {
    is: 'Product Feedback',
    then: schema => schema.required('Street address is required'),
    otherwise: schema => schema,
  }),
  city: Yup.string().when('contact_reason', {
    is: 'Product Feedback',
    then: schema => schema.required('City is required'),
    otherwise: schema => schema,
  }),
  state: Yup.string().when('country', {
    is: 'US',
    then: schema => schema.required('State is required'),
    otherwise: schema => schema,
  }),
  province: Yup.string().when('country', {
    is: (province: string) => province === 'CA' || province === 'AU',
    then: schema => schema.required('Province is required'),
    otherwise: schema => schema,
  }),
  zip_code: Yup.string().when('contact_reason', {
    is: 'Product Feedback',
    then: schema => schema.required('Postal code is required'),
    otherwise: schema => schema,
  }),
  country: Yup.string().when('contact_reason', {
    is: 'Product Feedback',
    then: schema => schema.required('Country is required'),
    otherwise: schema => schema,
  }),
  flavor: Yup.string().when('contact_reason', {
    is: 'Product Feedback',
    then: schema => schema.required('Related product is required'),
    otherwise: schema => schema,
  }),
  product_upc: Yup.string().when('contact_reason', {
    is: 'Product Feedback',
    then: schema =>
      schema
        .length(10, 'Product UPC must be exactly 10 digits')
        .matches(/^\d{10}$/, 'Product UPC entered incorrectly')
        .required('Product UPC is required'),
    otherwise: schema => schema,
  }),
  production_code: Yup.string().when('contact_reason', {
    is: 'Product Feedback',
    then: schema => schema.required('Production code is required'),
    otherwise: schema => schema,
  }),
  message: Yup.string().max(1000, 'Too Long').required('Message is required'),
  email_opt_in: Yup.boolean(),
  accept_legal: Yup.boolean()
    .required('Privacy policy and Terms of Use consent is required')
    .oneOf([true], 'Privacy policy and Terms of Use consent is required'),
  // Uncomment below for phone number field validation example
  // phone_number: Yup.string()
  //   .matches(
  //     /^(\+?[1]{1}[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, // Regex for typical US phone number
  //     'Phone number is not valid'
  //   )
  //   .required('A phone number is required'),
});
